const PageReducer = (state: any, action: any) => {
    const { payload, type } = action
    switch (type) {
        default: {
            return state 
        }
            
    }
}
export default PageReducer